export var LineHeights = {
  H1: 40,
  H2: 28,
  H3: 24,
  H4: 24,
  H5: 24,
  H6: 24,
  BODY: 24,
  SMALL: 20,
  Large: {
    H1: 64,
    H2: 40,
    H3: 28
  }
};